<template>
    <div class="row">
        <div class="container-filters">
            <div class="panel">
                <div class="panel-header">
                    <div class="filter-container">
                        <div class="container">
                            <div class="filter-options">
                                <div class="filter-item">
                                    <label>Show by Industries</label>
                                    <el-select placeholder="All Industries" size="large" :clearable="true"
                                               v-model="selectedIndustry"
                                               @change="applyFilter('industry')">
                                        <el-option label="All Industries" key="all-industries" value="">All Industries</el-option>

                                        <el-option
                                            v-for="industry in optionsIndustries"
                                            :disabled="availableFilters.indexOf(industry.slug.en)===-1"
                                            :key="industry.slug.en"
                                            :label="industry.name.en"
                                            :value="industry.name.en">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="filter-item">
                                    <label>from</label>
                                    <el-select placeholder="Order By" size="large" :clearable="true"
                                               v-model="selectedSort"
                                               @change="applyFilter('sort')">

                                        <el-option
                                            v-for="sortItem in optionsSort"
                                            :key="sortItem.slug"
                                            :label="sortItem.name"
                                            :value="sortItem.slug">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="filter-buttons">
                                <i class="fas fa-redo text-light mr-3" style="font-size: 18px" @click="clearFilters"></i>

                                <!--<prolit-button plain @click="changeGridType('grid')" :active="true" name="grid">-->
                                    <!--<i class="fas fa-th"></i>-->
                                <!--</prolit-button>-->
                                <!--<prolit-button plain @click="changeGridType('list')" :active="false" name="list">-->
                                    <!--<i class="fas fa-list"></i>-->
                                <!--</prolit-button>-->
                            </div>
                        </div>
                    </div>
                </div>
                <!--<div class="container-grid">-->
                    <!--<div class="container">-->
                        <!--<div class="card-deck panel-body">-->

                            <!--<slot v-if="displayBody" :data="resourcesLoaded" :type="gridType"></slot>-->

                            <!--<div v-else>-->
                                <!--<h3 class="text-center">No data available</h3>-->
                            <!--</div>-->
                        <!--</div>                    -->

                    <!--</div>-->
                <!--</div>-->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted(){
            this.availableFilters = this.initialFilterAvailable;
        },
        props:{
            initialFilterAvailable:{
                required:false,
                default(){
                    return []
                }
            }
        },
        data(){
            return {
                selectedIndustry:'',
                selectedSort:'',
                availableFilters:[],
            }
        },
        computed:{
            optionsIndustries(){
                return window.App.app.industries;
            },
            optionsSort(){
                return window.App.app.jobsOrderOptions;
            }
        },
        methods:{
            applyFilter(filter){
                let value = filter === 'industry'? this.selectedIndustry : this.selectedSort;
                prolitEvents.$emit('filterJobsChanges',{
                    value:value,
                    filter:filter,
                });
            },
            changeGridType(type){
                eventsBuffer.$emit('changedGridType', {
                    type:type
                });
            },
            clearFilters(){
                this.selectedIndustry= "";
                this.selectedSort= "";
                eventsBuffer.$emit('clearFilter');
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/jobs/FilterBar.vue